module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "main-wrap",
    attrs: {
      "id": "wrap"
    }
  }, [_c('component-header'), _vm._v(" "), _c('div', {
    staticClass: "pager"
  }, [_c('div', {
    staticClass: "container"
  }, [(_vm.loading) ? _c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "loading-md"
  })]) : _c('div', [_c('div', {
    staticClass: "row grid-1"
  }, [_vm._l((_vm.market.business_markets), function(bz, index) {
    return _c('div', {
      staticClass: "card col-xs-6",
      staticStyle: {
        "height": "40vh",
        "padding": "0"
      }
    }, [_c('a', {
      staticClass: "card-link",
      staticStyle: {
        "text-decoration": "none",
        "color": "inherit"
      },
      attrs: {
        "href": '/' + bz.business_username
      }
    }, [_c('div', {
      staticStyle: {
        "height": "80%",
        "width": "100%",
        "background-position": "center",
        "background-size": "contain"
      },
      style: ({
        'background-image': 'url(' + bz.business_banner_image + ')'
      })
    }), _vm._v(" "), _c('p', [_vm._v(_vm._s(bz.business_name))])])])
  }), _vm._v(" "), _c('div', {
    staticClass: "card col-xs-6",
    staticStyle: {
      "height": "40vh",
      "padding": "0"
    }
  }, [_c('a', {
    staticClass: "card-link",
    staticStyle: {
      "text-decoration": "none",
      "color": "inherit"
    },
    attrs: {
      "href": '#'
    }
  }, [_c('div', {
    staticStyle: {
      "height": "80%",
      "width": "100%",
      "background-position": "center",
      "background-size": "contain",
      "background-image": "url('/static/assets/images/showslive.jpg')"
    }
  }), _vm._v(" "), _c('p', [_vm._v("Events")])])])], 2)])])]), _vm._v(" "), _c('component-footer')], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-0f1bf178"}!./src/pages/Timeline/template.html
// module id = 247
// module chunks = 0